import { CardContent } from '@mui/material';
import React, { type FC } from 'react';
import CGVContent from '../CGVContent';
import { StyledCardStyle, StyledContainer } from './style';

const DigidomCgv: FC = () => {
  return (
    <StyledContainer>
      <StyledCardStyle>
        <CardContent>
          <CGVContent />
        </CardContent>
      </StyledCardStyle>
    </StyledContainer>
  );
};

export default DigidomCgv;
